export const initialState = {
    loader: false,
    cartList: [],
    error: ''
}